import {
	Component,
	ElementRef,
	EventEmitter,
	Inject,
	OnDestroy,
	OnInit,
	Output,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { RestService } from 'cargo-chief-commons';
import { UrlService } from '@service/url/url.service';
import { UtilService } from '@service/util/util.service';
import { NoteListComponent, NoteType } from '@notes/note-list/note-list.component';

@Component({
	selector: 'app-quick-notes-view-dialog',
	templateUrl: './quick-notes-view-dialog.html',
	styleUrls: ['./quick-notes-view-dialog.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class QuickNotesViewDialog implements OnInit, OnDestroy {
	carrierId: string = null;
	projectId: string = null;
	noteType: NoteType;
	name: string;
	content = '';
	isAdding = false;
	showAddNote = false;

	@ViewChild(NoteListComponent)
	notesListComponent: NoteListComponent;
	@ViewChild('lastDiv', { read: ElementRef })
	lastDiv: ElementRef;
	@Output() notesDialogClosed = new EventEmitter<{
		projectId: string;
		carrierId: string;
		count: number;
	}>();

	constructor(
		public dialogRef: MatDialogRef<QuickNotesViewDialog>,
		@Inject(MAT_DIALOG_DATA)
		public data: {
			carrierId: string;
			truckLaneId: string;
			name: string;
			projectId: string;
			noteType: NoteType;
		},
		private urlService: UrlService,
		private restService: RestService,
		private utilService: UtilService
	) {
		this.carrierId = this.data.carrierId;
		this.projectId = this.data.projectId;
		this.noteType = this.data.noteType;
		this.name = this.data.name;
	}

	ngOnInit() {}

	closeDialog() {
		this.dialogRef.close();
	}

	openAddNoteInput() {
		this.showAddNote = true;
		setTimeout(() => {
			if (!this.utilService.isNullOrUndefined(this.lastDiv.nativeElement)) {
				this.lastDiv.nativeElement.scrollIntoView({ behavior: 'smooth' });
			}
		});
	}

	closeAddNoteInput() {
		this.showAddNote = false;
	}

	carrierNoteType(): boolean {
		return this.noteType === NoteType.CARRIER;
	}

	ngOnDestroy(): void {
		if (
			this.notesListComponent &&
			!this.utilService.isNullOrUndefined(this.notesListComponent.noteCount)
		) {
			const notesCount = this.notesListComponent.noteCount;
			const data = {
				projectId: this.projectId,
				carrierId: this.carrierId,
				count: notesCount,
			};
			this.notesDialogClosed.emit(data);
		}
		this.isAdding = false;
		this.showAddNote = false;
		this.carrierId = null;
	}
}
